export const timeline = {
today: "Aujourd'hui",
yesterday: "Hier",
emptyTitle: "Aucune activité",
emptySub: "Les événements liés à ce flux apparaîtront ici en temps réel.",
filters: {
  contact: "Contact",
all: "Tous",
asset: "Actif",
inspection: "Inspection",
job: "Intervention",
request: "Demande",
report: "Rapport",
},
summary: {
label: "Résumé IA",
sinceToggle: "Depuis ma dernière visite",
btnSummarise: "Résumer",
btnRegenerate: "Régénérer",
btnLoading: "Résumé en cours…",
loading: "Lecture de la chronologie…",
emptyHint: "Appuyez sur Résumer pour obtenir un aperçu de 2-4 phrases de cet actif.",
emptyHintSite: "Appuyez sur Résumer pour obtenir un aperçu de 2-4 phrases de ce site.",
emptyHintContact: "Appuyez sur Résumer pour obtenir un aperçu de 2-4 phrases de ce contact.",
errorFallback: "Impossible de charger le résumé. Veuillez réessayer.",
},
events: {
assetCreated: "Actif créé",
inspectionStarted: "Inspection démarrée",
inspectionCompleted: "Inspection terminée",
issueRaised: "Anomalie signalée",
requestRaised: "Demande créée",
approvalReceived: "Approbation reçue",
quoteReceived: "Devis reçu",
jobCreated: "Intervention créée",
jobAssigned: "Intervention attribuée",
workCompleted: "Travaux terminés",
evidenceAdded: "Pièce justificative ajoutée",
reportGenerated: "Rapport généré",
},
};
